import request from '@/utils/request'

const friendshipLinkURL = {
  Add: '/links/create',
  List: '/links/list',
  Detail: '/links/view',
  Update: '/links/update',
  Delete: '/links/delete'
}

// 创建友情链接
export function addLink (data) {
  return request({
    url: friendshipLinkURL.Add,
    method: 'post',
    data
  })
}

// 友情链接详情
export function detailLink (data) {
  return request({
    url: friendshipLinkURL.Detail,
    method: 'post',
    data
  })
}

// 更新友情链接
export function updateLink (data) {
  return request({
    url: friendshipLinkURL.Update,
    method: 'post',
    data
  })
}

// 友情链接列表
export function listLink (data) {
  return request({
    url: friendshipLinkURL.List,
    method: 'post',
    data
  })
}

// 删除友情链接
export function deleteLink (data) {
  return request({
    url: friendshipLinkURL.Delete,
    method: 'post',
    data
  })
}

export default {
  addLink,
  listLink,
  detailLink,
  updateLink,
  deleteLink
}
